export const BREAKPOINTS = {
	xs: 480,
	s: 768,
	m: 1024,
	l: 1440,
	xl: 1920,
};
